import { createGenericListItemReducer } from "common/genericListItemReducer";
import { combineReducers } from "redux";
import {
  REORDER_REQUESTED,
  REORDER_REQUEST_FAILED,
  REORDER_REQUEST_RECEIVED,
  REORDER_STATUS_RECEIVED,
  REORDER_STATUS_REQUESTED,
  REORDER_STATUS_REQUEST_FAILED
} from "./reorderActions";

export const reorder = combineReducers({
  availability: createGenericListItemReducer(
    REORDER_STATUS_REQUESTED,
    REORDER_STATUS_RECEIVED,
    REORDER_STATUS_REQUEST_FAILED
  ),
  reorder: createGenericListItemReducer(REORDER_REQUESTED, REORDER_REQUEST_RECEIVED, REORDER_REQUEST_FAILED, null)
});
